/* Desi 99 — interactions (scroll reveal, nav, FAQ accordion, recipe tabs) */
(function () {
  'use strict';

  var HIDDEN = ['opacity-0', 'translate-y-4', 'translate-y-8', 'translate-y-12'];

  function revealIn(root) {
    var items = root.querySelectorAll('.js-reveal');
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      for (var h = 0; h < HIDDEN.length; h++) el.classList.remove(HIDDEN[h]);
      el.classList.remove('js-reveal');
      el.classList.add('opacity-100', 'translate-y-0');
    }
  }

  function initReveal() {
    var roots = document.querySelectorAll('[data-reveal-root]');
    if (!('IntersectionObserver' in window)) {
      revealIn(document);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          revealIn(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -50px 0px' });
    for (var i = 0; i < roots.length; i++) io.observe(roots[i]);
  }

  /* ---------- navbar ---------- */
  var SCROLLED = ['glass-dark', 'py-3', 'shadow-2xl', 'shadow-black/20'];
  var TOP = ['py-5', 'bg-transparent'];

  function initNav() {
    var nav = document.querySelector('[data-navbar]');
    if (nav) {
      var onScroll = function () {
        var down = window.scrollY > 20;
        SCROLLED.forEach(function (c) { nav.classList.toggle(c, down); });
        TOP.forEach(function (c) { nav.classList.toggle(c, !down); });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var menu = document.querySelector('[data-nav-menu]');
    var panel = document.querySelector('[data-nav-panel]');
    var open = false;

    function setMenu(next) {
      open = next;
      if (menu) {
        menu.classList.toggle('opacity-100', open);
        menu.classList.toggle('pointer-events-auto', open);
        menu.classList.toggle('opacity-0', !open);
        menu.classList.toggle('pointer-events-none', !open);
      }
      if (panel) {
        panel.classList.toggle('translate-x-0', open);
        panel.classList.toggle('translate-x-full', !open);
      }
      var bars = document.querySelectorAll('[data-bar]');
      for (var i = 0; i < bars.length; i++) {
        var bar = bars[i];
        var which = bar.getAttribute('data-bar');
        if (which === '1') {
          bar.classList.toggle('rotate-45', open);
          bar.classList.toggle('translate-y-2', open);
        } else if (which === '2') {
          bar.classList.toggle('opacity-0', open);
        } else {
          bar.classList.toggle('-rotate-45', open);
          bar.classList.toggle('-translate-y-2', open);
        }
      }
      document.body.style.overflow = open ? 'hidden' : '';
      var toggle = document.querySelector('[data-nav-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    var toggles = document.querySelectorAll('[data-nav-toggle]');
    for (var t = 0; t < toggles.length; t++) {
      toggles[t].addEventListener('click', function () { setMenu(!open); });
    }
    var closers = document.querySelectorAll('[data-nav-close]');
    for (var c = 0; c < closers.length; c++) {
      closers[c].addEventListener('click', function () { setMenu(false); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) setMenu(false);
    });
  }

  /* ---------- FAQ accordion ---------- */
  function setFaq(item, open) {
    item.setAttribute('data-open', open ? '1' : '0');
    var panel = item.querySelector('[data-faq-panel]');
    var dot = item.querySelector('[data-faq-dot]');
    var chev = item.querySelector('[data-faq-chev]');
    var q = item.querySelector('[data-faq-q]');
    var btn = item.querySelector('[data-faq-toggle]');
    if (panel) {
      panel.classList.toggle('max-h-96', open);
      panel.classList.toggle('opacity-100', open);
      panel.classList.toggle('max-h-0', !open);
      panel.classList.toggle('opacity-0', !open);
    }
    if (dot) {
      dot.classList.toggle('bg-brand-500', open);
      dot.classList.toggle('text-white', open);
      dot.classList.toggle('bg-white/10', !open);
      dot.classList.toggle('text-white/50', !open);
    }
    if (chev) chev.classList.toggle('rotate-180', open);
    if (q) {
      q.classList.toggle('text-white', open);
      q.classList.toggle('text-white/70', !open);
      q.classList.toggle('group-hover:text-white', !open);
    }
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initFaq() {
    var items = document.querySelectorAll('[data-faq-item]');
    for (var i = 0; i < items.length; i++) {
      items[i].setAttribute('data-open', i === 0 ? '1' : '0');
      (function (item) {
        var btn = item.querySelector('[data-faq-toggle]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var wasOpen = item.getAttribute('data-open') === '1';
          for (var j = 0; j < items.length; j++) setFaq(items[j], false);
          setFaq(item, !wasOpen);
        });
      })(items[i]);
    }
  }

  /* ---------- recipe category tabs ---------- */
  var TAB_ON = ['bg-gradient-to-r', 'from-brand-500', 'to-brand-600', 'text-white',
    'shadow-lg', 'shadow-brand-500/25'];
  var TAB_OFF = ['glass', 'text-white/60', 'hover:text-white', 'hover:bg-white/10'];

  function initTabs() {
    var tabs = document.querySelectorAll('[data-cat-tab]');
    var panels = document.querySelectorAll('[data-cat-panel]');
    for (var i = 0; i < tabs.length; i++) {
      (function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-cat-tab');
          for (var j = 0; j < tabs.length; j++) {
            var on = tabs[j] === tab;
            TAB_ON.forEach(function (c) { tabs[j].classList.toggle(c, on); });
            TAB_OFF.forEach(function (c) { tabs[j].classList.toggle(c, !on); });
          }
          for (var k = 0; k < panels.length; k++) {
            panels[k].classList.toggle('hidden', panels[k].getAttribute('data-cat-panel') !== id);
          }
        });
      })(tabs[i]);
    }
  }

  function boot() {
    initReveal();
    initNav();
    initFaq();
    initTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
